import { isEmpty } from 'lodash';
import { ShowPageType } from '../../types/launch';
import { RootState } from '../../types/redux';
import { EMPTY_ARRAY } from '../../utils/defaults';
import { FALLBACK_TILE_THUMBNAIL } from '../../utils/launch';
import { SIGNUP_NESTED, createAppPathAndPersistQuery } from '../../utils/router';
import { PREMIUM_CORE_ADD_ONS } from '../../web-shared/utils/billing';
import { getAddOns } from './billing';
import { getImageCDNBaseURL, getIsUserLoggedIn } from './config';

export function getShow({ launch }: RootState) {
  return launch.show;
}

export function getShowPageType({ launch }: RootState) {
  const { show, episode } = launch;
  if (isEmpty(show)) {
    return undefined;
  }
  if (!isEmpty(episode)) {
    return ShowPageType.EPISODE;
  }
  if ('latestSeasonNum' in show) {
    return ShowPageType.SHOW;
  }
  // KU – there isn't a more elegant way to determine if the show landing page
  // should have the Event treatment
  if (show.genres?.includes('Awards')) {
    return ShowPageType.EVENT;
  }
  return ShowPageType.MOVIE;
}

export function getBackdropImageURL({ launch }: RootState) {
  return launch.backdrop;
}

export function getChannel(state: RootState) {
  const { launch } = state;
  const { channel } = getShow(state) || {};
  return channel || launch.channel;
}

export function getLaunchPageType({ launch }: RootState) {
  return launch.type;
}

export function getEpisode({ launch }: RootState) {
  return launch.episode;
}

export function getTitleOverride({ launch }: RootState) {
  return launch.title;
}

export function getLaunchRedirect({ launch }: RootState) {
  return launch.redirect;
}

export function getCollection({ launch }: RootState) {
  return launch.collection || EMPTY_ARRAY;
}

export function getLaunchAssetId({ launch }: RootState) {
  return (launch.episode || launch.show || launch.channel)?.id;
}

export function getFallbackTileImageURL(state: RootState) {
  const imageCDNBaseURL = getImageCDNBaseURL(state);
  return `${imageCDNBaseURL}${FALLBACK_TILE_THUMBNAIL}`;
}

export function getRequiredAddOn(state: RootState) {
  const channel = getChannel(state);
  const addOns = getAddOns(state);
  const requiredAddOn = addOns?.find(addOn => addOn.id === channel?.addOnId);

  return requiredAddOn && PREMIUM_CORE_ADD_ONS.has(requiredAddOn.id) ? requiredAddOn : undefined;
}

export function getAssetSignupHref(state: RootState, assetURLOverride?: string) {
  const isUserLoggedIn = getIsUserLoggedIn(state);
  const launchRedirectURL = getLaunchRedirect(state);
  const assetURL = assetURLOverride || launchRedirectURL;
  const additionalParams = isUserLoggedIn || !assetURL ? undefined : { redirect_uri: assetURL };
  const url = isUserLoggedIn ? assetURL : SIGNUP_NESTED;
  return url && createAppPathAndPersistQuery(url, additionalParams);
}

export function getLiveAsset({ launch }: RootState) {
  return launch.liveAsset;
}

export function getIsNewUserFastPlayable({ launch }: RootState) {
  return launch.newUserFastPlayable;
}
